// userStore — глобальное состояние авторизованного юзера.
// Подгружается при старте App.jsx, если есть валидный токен.
import { create } from 'zustand';
import AuthService from '../API/AuthService';

const useUserStore = create((set) => ({
    profile: null,        // данные Profile из user-микросервиса
    centre: null,         // данные B2BCentre (если есть)
    loading: true,        // первичная загрузка после монтирования

    async refresh() {
        if (!AuthService.isAuthenticated()) {
            set({ profile: null, centre: null, loading: false });
            return;
        }
        set({ loading: true });
        const [profile, centre] = await Promise.all([
            AuthService.fetchProfile(),
            AuthService.fetchMyCentre(),
        ]);
        set({ profile, centre, loading: false });
    },

    setProfile(profile) { set({ profile }); },
    setCentre(centre) { set({ centre }); },

    logout() {
        AuthService.logout();
        set({ profile: null, centre: null });
    },
}));

export default useUserStore;
